<template>
  <section class="card_style">
    <!-- Skeleton -->
    <div class="row" v-if="loading && $route.params.id">
      <div class="col-12 my-3">
        <Skeleton width="20%" class="my-2" />
      </div>
      <div class="col-12 my-3" v-for="i in 2" :key="i">
        <Skeleton width="20%" class="my-2" />
        <Skeleton width="70%" height="2rem" class="my-2" />
      </div>
      <div class="col-12 my-3">
        <Skeleton width="10%" height="10rem" />
      </div>
    </div>

    <!-- Form -->
    <form @submit.prevent="addAboutus" v-else>
      <div class="main_aboutus">
        <h4>{{ $t("Add Aboutus") }}</h4>
      </div>
      <div class="row">
        <!-- Title Fields -->
        <div class="col-6" v-for="(lang) in ['en', 'ar']" :key="'title-' + lang">
          <div class="form-group">
            <label :for="`title_${lang}`">{{ $t(`title_${lang}`) }}</label>
            <input type="text" class="form-control" :id="`title_${lang}`" v-model="form[`title_${lang}`]" />
          </div>
        </div>

        <!-- Description Fields -->
        <div class="col-6" v-for="(lang) in ['en', 'ar']" :key="'desc-' + lang">
          <div class="form-group">
            <label :for="`description_${lang}`">{{ $t(`description_${lang}`) }}</label>
            <input type="text" class="form-control" :id="`description_${lang}`" v-model="form[`description_${lang}`]" />
          </div>
        </div>

        <!-- Main Images -->
        <div class="col-12">
          <label class="form-label">{{ $t("image") }}</label>
          <input type="file" class="form-control" accept="image/*" multiple @change="onFileChange" />
          <div class="image-conteiner" v-if="imagePreviews.length">
            <img :src="imagePreviews[0]" class="entry_image" />
            <input class="form-control" type="text" v-model="image_alt[0]" placeholder="Alt text" />
          </div>
        </div>

        <!-- Add Detail Button -->
        <i class="fa-solid fa-plus add-icon col-12 " @click="addDetailsEntry"></i>

        <!-- About Us Details -->
        <div class="about-us-details-list row mt-2" v-for="(item, index) in aboutus_details" :key="'details-' + index">
          <div class="col-6">
            <label>{{ $t(`title_ar`) }}</label>
            <input type="text" class="form-control" v-model="item[`details_title_ar`]" />
          </div>
          <div class="col-6">
            <label>{{ $t(`title_en`) }}</label>
            <input type="text" class="form-control" v-model="item[`details_title_en`]" />
          </div>

          <div class="col-6">
            <label>{{ $t(`description_ar`) }}</label>
            <input type="text" class="form-control" v-model="item[`details_description_ar`]" />
          </div>
          <div class="col-6">
            <label>{{ $t(`description_en`) }}</label>
            <input type="text" class="form-control" v-model="item[`details_description_en`]" />
          </div>

          <div class="col-12">
            <label>{{ $t("image") }}</label>
            <input type="file" class="form-control" multiple @change="onFileChange2(index, $event)" />
            <div class="main-image-container">
              <div v-for="(img, idx) in item.details_imagePreviews" :key="'details-image-' + idx"
                class="image-conteiner">
                <img :src="img" class="entry_image" />
                <input class="form-control" type="text" v-model="item.details_image_alt[idx]" placeholder="Alt text" />
              </div>
            </div>
          </div>

          <!-- Remove Detail Button -->
          <div class="col-12 mt-2" v-if="aboutus_details.length > 1">
            <button type="button" class="btn btn-danger btn-sm" @click="removeDetailsEntry(index)">
              {{ $t("Remove") }}
            </button>
          </div>
        </div>

        <!-- Submit -->
        <div class="col-12 mt-3">
          <button type="submit" class="btn PrimaryButton">
            {{ $t("save") }}
          </button>
        </div>
      </div>
    </form>
  </section>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import Skeleton from "primevue/skeleton";

export default {
  data() {
    return {
      v$: useVuelidate(),
      loading: false,
      form: {
        title_en: "",
        title_ar: "",
        description_en: "",
        description_ar: "",
      },
      fileData: [],
      imagePreviews: [],
      image_alt: [],
      aboutus_details: [
        {
          details_title_ar: "",
          details_title_en: "",
          details_description_ar: "",
          details_description_en: "",
          details_imageEntry: [],
          details_imagePreviews: [],
          details_image_alt: [],
        },
      ],
      section: {},
    };
  },
  validations() {
    return {
      form: {
        title_en: { required },
        title_ar: { required },
        description_en: { required },
        description_ar: { required },
      },
    };
  },
  methods: {
    onFileChange(e) {
      const files = Array.from(e.target.files);
      this.fileData = [];
      this.imagePreviews = [];
      files.forEach((file) => {
        this.fileData.push(file);
        const reader = new FileReader();
        reader.onload = (e) => this.imagePreviews.push(e.target.result);
        reader.readAsDataURL(file);
      });
    },
    onFileChange2(index, e) {
      const files = Array.from(e.target.files);
      const details = this.aboutus_details[index];
      details.details_imageEntry = [];
      details.details_imagePreviews = [];
      files.forEach((file) => {
        details.details_imageEntry.push(file);
        const reader = new FileReader();
        reader.onload = (e) => details.details_imagePreviews.push(e.target.result);
        reader.readAsDataURL(file);
      });
    },
    addDetailsEntry() {
      this.aboutus_details.push({
        details_title_ar: "",
        details_title_en: "",
        details_description_ar: "",
        details_description_en: "",
        details_imageEntry: [],
        details_imagePreviews: [],
        details_image_alt: [],
      });
    },
    removeDetailsEntry(index) {
      if (this.aboutus_details.length > 1) {
        this.aboutus_details.splice(index, 1);
      }
    },
    addAboutus() {
      const formData = new FormData();
      formData.append("title_ar", this.form.title_ar);
      formData.append("title_en", this.form.title_en);
      formData.append("description_ar", this.form.description_ar);
      formData.append("description_en", this.form.description_en);
      
      // Append main images
      this.fileData.forEach((file) => {
        formData.append(`image`, file);
      });

      this.aboutus_details.forEach((item, i) => {
        formData.append(`about_us_details[${i}][title_ar]`, item.details_title_ar);
        formData.append(`about_us_details[${i}][title_en]`, item.details_title_en);
        formData.append(`about_us_details[${i}][description_ar]`, item.details_description_ar);
        formData.append(`about_us_details[${i}][description_en]`, item.details_description_en);
        item.details_imageEntry.forEach((imgFile) => {
          formData.append(`about_us_details[${i}][image]`, imgFile);
        });
      });

      axios
        .post("/about_us_create_or_update", formData)
        .then(({ data }) => {
          Swal.fire({ icon: "success", text: data.message });
        })
        .catch((err) => {
          Swal.fire({ icon: "error", text: err.response?.data?.message || "Error occurred" });
        });
    },

    FetchSections() {
      this.loading = true;
      axios
        .get(`/fetch_about_us`)
        .then(({ data }) => {
          console.log(data.data, "fetched data");

          if (data.data) {
            // Fill the main form fields
            this.form.title_en = data.data.title || "";
            this.form.title_ar = data.data.title || ""; // You might want to have separate AR field in API
            this.form.description_en = data.data.description || "";
            this.form.description_ar = data.data.description || ""; // You might want to have separate AR field in API

            // Handle main image
            if (data.data.image) {
              this.imagePreviews = [data.data.image];
              this.image_alt = [""]; // Add alt text if available in API
              this.fileData = [];
            } else {
              this.imagePreviews = [];
              this.image_alt = [];
              this.fileData = [];
            }

            // Handle about details
            if (data.data.about_details && data.data.about_details.length > 0) {
              this.aboutus_details = data.data.about_details.map(detail => ({
                details_title_ar: detail.titles || "", // You might want to have separate AR field in API
                details_title_en: detail.titles || "",
                details_description_ar: detail.description || "", // You might want to have separate AR field in API
                details_description_en: detail.description || "",
                details_imagePreviews: detail.image ? [detail.image] : [],
                details_image_alt: detail.image ? [""] : [], // Add alt text if available in API
                details_imageEntry: [],
              }));
            } else {
              // Initialize with empty entry if no details exist
              this.aboutus_details = [
                {
                  details_title_ar: "",
                  details_title_en: "",
                  details_description_ar: "",
                  details_description_en: "",
                  details_imagePreviews: [],
                  details_image_alt: [],
                  details_imageEntry: [],
                },
              ];
            }
          }

          this.loading = false;
        })
        .catch((err) => {
          console.error("Error fetching data:", err);
          this.loading = false;
        });
    }
  },
  components: {
    Skeleton,
  },
  mounted() {
    this.FetchSections();
  },
};
</script>

<style scoped>
.add-icon {
  margin: auto;
  background-color: #0f3450;
  width: fit-content;
  padding: 3px;
  border-radius: 5px;
  cursor: pointer;
}

.fa-plus:before {
  color: white;
}

.image-conteiner {
  display: flex;
  gap: 10px;
  align-items: center;
  margin-top: 10px;
}

.entry_image {
  width: 100px;
  height: auto;
  object-fit: cover;
}
</style>